import request from '@/common/request'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  queryProcessInfo: params => {
    return request({
      url: '/processInfo',
      method: 'get',
      params
    })
  },
  getProcessInfo: params => {
    return request({
      url: '/processInfo/getInfos',
      method: 'get',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/processInfo.js